/**
 * Injects context (privat/proff) into all search forms so that
 * the search results page knows which context the search originated from.
 */
const isProff = window.location.pathname.startsWith('/proff')
const context = isProff ? 'proff' : 'privat'

document.querySelectorAll('form[role="search"]').forEach((form) => {
	// Skip if context field already exists (e.g. the search-results block form)
	if (form.querySelector('input[name="context"]')) return

	const hidden = document.createElement('input')
	hidden.type = 'hidden'
	hidden.name = 'context'
	hidden.value = context
	form.appendChild(hidden)
})
